export const setShellVersion = (version: string) => {
	window.nabshell = {
		version: version,
	};
};
